import React from 'react';
import styles from './ChartSetPreferenceState.module.css';
import { useSelector } from 'react-redux';
import { selectUserPreferences } from '../../../../../redux/selectors';
import { selectUserPreference } from '../../../../../redux/UserPreferences';

function ChartSetPreferenceState({ preference }) {
  const {
    state: { charts = [] }
  } = preference;

  return (
    <div className={styles.root}>
      {charts.map(
        (chart, index) =>
          chart.preferenceId !== 'chart_placeholder' && (
            <ChartSetPreferenceStateItem key={`${chart.preferenceId}-${index}`} preferenceId={chart.preferenceId} />
          )
      )}
    </div>
  );
}

export default ChartSetPreferenceState;

function ChartSetPreferenceStateItem({ preferenceId }) {
  const preference = useSelector((state) => selectUserPreference(selectUserPreferences(state), preferenceId));

  return preference ? <div className={styles.item}>{preference?.name}</div> : null;
}
